import type { IUser } from '@wix/yoshi-flow-editor';
import { createAction, GLOBALS, type CommonThunkAction } from '@wix/communities-blog-client-common';

export const FETCH_CURRENT_USER_SUCCESS = 'currentUser/FETCH_SUCCESS';

const fetchCurrentUserRequest = createAction('currentUser/FETCH_REQUEST');
const fetchCurrentUserSuccess = createAction(FETCH_CURRENT_USER_SUCCESS);
const fetchCurrentUserFailure = createAction('currentUser/FETCH_FAILURE');

export const fetchCurrentUser =
  (instance: string | undefined): CommonThunkAction =>
  async (dispatch, _, { httpClient, errorHandler }) => {
    dispatch(fetchCurrentUserRequest());
    const { withErrorHandler, getResolvedError } = errorHandler;

    try {
      const response = await withErrorHandler(
        () =>
          httpClient.get<{ currentUser: IUser }>(
            `${GLOBALS.API_BASE_URL_CLIENT}/_api/users/current`,
            {
              headers: {
                instance,
                Authorization: instance,
              },
            },
          ),
        {
          errorCodesMap: {},
        },
      );

      dispatch(fetchCurrentUserSuccess(response.data));
      return response;
    } catch (error) {
      dispatch(fetchCurrentUserFailure());
      getResolvedError(error);
    }
  };
